const View = require('public_framework/view')
const fetchCurrentRole = require('public_framework/services/fetch_current_role')

class SignUp extends View {
  constructor () {
    super(...arguments)

    fetchCurrentRole((user) => {
      this.$formInner().show()

      if (this.isToptalOnlyEvent()) {
        if (!user || !user.active) {
          this.$toptalOnlyEventView().show()
          return
        }
      }

      if (!user) {
        // front/apps/public/base/javascripts/components/form/views/form.js:showLoader logic only supports a single button in the form
        this.$userView().find('button').remove()
        this.$guestView().show()
        return
      }

      // front/apps/public/base/javascripts/components/form/views/form.js:showLoader logic only supports a single button in the form
      this.$guestView().find('button').remove()
      this.$userName().html(user.full_name)
      this.$userID().val(user.role_id)
      this.$userEmail().val(user.email)

      if (this.isAttending(user.role_id)) {
        this.$form().addClass('has-confirmation')
        return
      }

      this.$userView().show()
    })
  }

  get els () {
    return {
      $userView: '@user_view',
      $guestView: '@guest_view',
      $userName: '@user_name',
      $userID: '@user_id',
      $userEmail: '@user_email',
      $form: '@form',
      $formInner: '@form_inner',
      $toptalUserView: '@toptal_user_view',
      $toptalOnlyEventCheck: '@toptal_only_event_check',
      $toptalOnlyEventView: '@toptal_only_event_view'
    }
  }

  isToptalOnlyEvent () {
    return Boolean(this.$toptalOnlyEventCheck().data('value'))
  }

  isAttending (roleId) {
    const attendees = this.$el.data('attendees') || []
    return attendees.indexOf(roleId) >= 0
  }

  showInnerForm () {
    this.$formInner().show()
  }
}

module.exports = SignUp



// WEBPACK FOOTER //
// ./front/apps/public/pages/community_event/javascripts/views/sign_up.js